import { z } from '../zod.js';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';
import { LivemodeFilterValidationSchema } from '../shared/livemode';

export const GetSubmissionInputValidationSchema = z.object({
  submissionId: ObjectIdStringValidationSchema.meta({
    description:
      'The ID of the submission to retrieve. Use `list_submissions` first if you need to discover a submission ID by email, name, page, customer, or date range.',
  }),
  livemode: LivemodeFilterValidationSchema,
});
